import { useCallback, useEffect, useState } from 'react';
import {
  getCustomAnalysisResult,
  refreshCustomAnalysisResult,
} from 'services/actions/ai_management_custom_analysis';

interface State {
  loaded: boolean;
  content: string | null;
  error: boolean;
  refreshing: boolean;
}

const INITIAL_STATE: State = { loaded: false, content: null, error: false, refreshing: false };

export function useCustomAnalysisResult(biddingId: number, enabled: boolean, versionKey?: string) {
  const [state, setState] = useState<State>(INITIAL_STATE);

  const load = useCallback(
    (active: () => boolean, isRefresh: boolean) => {
      const request = isRefresh
        ? refreshCustomAnalysisResult(biddingId)
        : getCustomAnalysisResult(biddingId);

      request
        .then((response) => {
          if (!active()) return;
          setState({
            loaded: true,
            content: response?.data?.content ?? null,
            error: false,
            refreshing: false,
          });
        })
        .catch((err) => {
          console.error('Erro ao carregar a análise personalizada gerada:', err);
          if (active())
            setState((prev) => ({ ...prev, loaded: true, error: true, refreshing: false }));
        });
    },
    [biddingId],
  );

  useEffect(() => {
    if (!enabled || !biddingId) {
      setState(INITIAL_STATE);
      return undefined;
    }

    let active = true;
    setState(INITIAL_STATE);
    load(() => active, false);

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, biddingId, versionKey]);

  const refresh = useCallback(() => {
    if (!enabled || !biddingId) return;
    setState((prev) => ({ ...prev, refreshing: true }));
    load(() => true, true);
  }, [enabled, biddingId, load]);

  return {
    content: state.content,
    loading: enabled && !state.loaded,
    refreshing: state.refreshing,
    error: state.error,
    refresh,
  };
}
